module.exports = __webpack_public_path__ + "static/media/p8_img4.919aca05.svg";